import { createRouter } from '@tanstack/react-router'
import { NotFound } from './features/shell/NotFound'
import { queryClient } from './lib/query'
import { routeTree } from './routeTree.gen'

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  // Loaders only warm the query cache; TanStack Query decides freshness.
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
  defaultPendingMs: 300,
  defaultNotFoundComponent: NotFound,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
